
const initialState = {
    language: 'English'
};

export default (state = initialState, action) => {
    switch(action.type){
        case 'CHANGE_LANGUAGE':
            return{
                language: action.language
            }     
    }
    return state;
};